import { useContext } from "react";
import SchematicContext from "../context/schematic_provider";

export default function useSchematic() {
  return useContext(SchematicContext);
}
